import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { createResource, useResource } from '@/lib/i18n'
import { initStore } from '@/store'
import { eventLogProducer } from '@/lib/event-logger'
import { Action } from '@@/action_pb'
import { isIOS, playPath } from '@/lib/utils'
import Image from 'next/image'
import { useWindowSize } from '@/lib/use-hooks/use-window-size'
import { IDownloadType, ILocation } from '@/lib/enums/device'

const resource = createResource({
  en: {
    downBtn: 'Download',
    text: 'Fast Loan 50 mio!',
  },
  id: {
    downBtn: 'Download',
    text: 'Pinjam kilat 50 juta!',
  },
})

let downloadBarSlotTaken = false

const Download = () => {
  const [isPrimaryInstance] = useState(() => {
    if (typeof window === 'undefined') {
      return true
    }
    if (downloadBarSlotTaken) {
      return false
    }
    downloadBarSlotTaken = true
    return true
  })

  const { t } = useResource(resource)
  const { width } = useWindowSize()
  const [isClose, setClose] = useState(initStore().ConfigStore.isClose)

  const downloadLink = isIOS()
    ? playPath(IDownloadType.IOS, '', ILocation.HOME)
    : playPath(IDownloadType.GOOGLE_PLAY, '', ILocation.HOME)
  const closeBtn = () => {
    initStore().ConfigStore.setClose(true)
    setClose(true)
  }
  const eventClickDownload = () => {
    eventLogProducer.push({
      action: Action.DOWNLOADBUTTONCLICK,
    })
    window.location.href = downloadLink
  }
  useEffect(() => {
    if (!isPrimaryInstance) {
      return
    }
    if (!isClose && width < 1000) {
      document.body.style.marginTop = '50px'
    } else {
      document.body.style.marginTop = '0'
    }
  }, [isPrimaryInstance, isClose, width])

  useEffect(() => {
    return () => {
      if (isPrimaryInstance) {
        downloadBarSlotTaken = false
      }
    }
  }, [isPrimaryInstance])

  if (!isPrimaryInstance) {
    return null
  }

  return (
    <DowloadBox>
      <div className={`download ${isClose ? 'hide-close' : ''}`}>
        <div className="mobile-menu">
          <Image
            width={20}
            height={20}
            quality={85}
            src={'/images/home/close-icon-white.png'}
            alt="mobile-close"
            onClick={() => closeBtn()}
          />
        </div>
        <div className="mobile-logo">
          <Image width={32} height={32} quality={85} src={'/images/home/kp-logo.png'} alt="mobile-logo" />
        </div>
        <span>{t('text')}</span>
        <span onClick={eventClickDownload} className="download-btn">
          {t('downBtn')}
        </span>
      </div>
    </DowloadBox>
  )
}
const DowloadBox = styled.div`
  @media only screen and (max-width: 1000px) {
    .download {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 50px;
      display: flex;
      align-items: center;
      z-index: 999;
      background-image: url('/images/home/download_bg.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      & > div {
        overflow: inherit !important;
      }
      &.hide-close {
        display: none !important;
      }
      .mobile-menu {
        margin: 0 6px 0 10px !important;
      }
      .mobile-logo {
        width: 32px;
        height: 32px;
      }
      span {
        padding-left: 16px;
        font-size: 16px;
        font-family: Roboto-Bold;
        font-weight: 500;
        color: #ffffff;
        line-height: 20px;
      }
      .download-btn {
        position: absolute;
        top: 54%;
        right: 10px;
        transform: translateY(-54%);
        height: 24px;
        background: linear-gradient(180deg, #feffe4 0%, #eeffdb 100%);
        box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.08);
        border-radius: 1400px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 11px;
        font-family: Roboto-Medium;
        font-weight: 500;
        color: #27d117;
        padding: 8px 15px;
      }
    }
  }
  @media only screen and (min-width: 1000px) {
    .download {
      display: none;
    }
  }
`
export default Download
